import { Box } from '@factorialco/deprecated-design-system'
import { Icon, IconType } from '@factorialco/factorial-one-react'
import { Counter } from '@factorialco/factorial-one-react/dist/experimental'

interface ControlBarButtonProps {
  isCanceled?: boolean
  isFocused?: boolean
  isOpen?: boolean
  icon: IconType
  onClick: () => void
  label: string
  pending?: number
}

export const ControlBarButton = ({
  isCanceled = false,
  isFocused = false,
  isOpen = false,
  icon,
  onClick,
  label,
  pending,
}: ControlBarButtonProps) => {
  return (
    <Box
      position="relative"
      padding="s2"
      borderRadius={{
        all: 'abs016',
      }}
      className={`border border-solid ${
        isFocused ? 'border-f1-border-selected-bold' : 'border-f1-background'
      }`}
    >
      <button
        title={label}
        onClick={onClick}
        type="button"
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: '40px',
          width: '40px',
          cursor: 'pointer',
        }}
        className={`rounded-lg border border-solid ${
          isOpen
            ? 'bg-f1-background-selected border-f1-border-selected-bold'
            : isCanceled
            ? 'bg-f1-background-tertiary border-f1-border'
            : 'bg-f1-background border-f1-border'
        } hover:bg-f1-background-hover`}
      >
        <Icon
          icon={icon}
          size="md"
          className={
            isCanceled ? 'text-f1-foreground-critical' : isOpen ? 'text-f1-foreground-selected' : ''
          }
        />
      </button>

      {pending && (
        <Box position="absolute" style={{ top: '-5px', right: '-5px' }}>
          <Counter size="md" type="selected" value={pending} />
        </Box>
      )}
    </Box>
  )
}
